var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.573C24.0026 16.8423 23.5895 16.1737 22.935 15.849L13.95 11.357C13.8702 11.317 13.8178 11.2376 13.8124 11.1485C13.8071 11.0594 13.8496 10.9742 13.924 10.925C15.3213 10.0055 15.8727 8.22584 15.24 6.67742C14.6073 5.129 12.9674 4.24467 11.3261 4.56676C9.68467 4.88885 8.5006 6.32731 8.5 7.99999C8.5 8.55228 8.94771 8.99999 9.5 8.99999C10.0523 8.99999 10.5 8.55228 10.5 7.99999C10.5005 7.2354 11.076 6.59352 11.836 6.50991C12.596 6.42629 13.2972 6.9277 13.4639 7.67391C13.6306 8.42011 13.2093 9.17227 12.486 9.41999C11.5973 9.72491 11.0004 10.5605 11 11.5C10.9998 11.879 11.2139 12.2256 11.553 12.395L20.9 17.026C21.004 17.0776 21.0589 17.1939 21.0324 17.307C21.0059 17.42 20.9051 17.5 20.789 17.5H3.261C3.14512 17.5005 3.04412 17.4212 3.01696 17.3086C2.98981 17.1959 3.04364 17.0794 3.147 17.027L8.955 14.064C9.27314 13.9014 9.4804 13.5815 9.4987 13.2247C9.51699 12.8679 9.34355 12.5284 9.0437 12.3342C8.74384 12.14 8.36314 12.1204 8.045 12.283L1.053 15.851C0.258516 16.2565 -0.154549 17.1537 0.0538991 18.021C0.262347 18.8883 1.038 19.4998 1.93 19.5H22.073C23.1366 19.4983 23.9983 18.6366 24 17.573Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger);
export default __webpack_public_path__ + "static/media/hanger.51cfe57c.svg";
export { ForwardRef as ReactComponent };